import { fabric } from "fabric";
import {isMobileDevice} from "../imageEditor";
const FontFaceObserver = require('fontfaceobserver');
import debounce from "lodash/debounce";

export default class TextService {
    store;
    imageEditor;
    canvas;

    constructor(store, imageEditor) {
        this.store = store;
        this.imageEditor = imageEditor;
        this.canvas = this.store.canvas;

        this.debouncedOnTextOptionsChanged = debounce(this.onTextOptionsChanged.bind(this), 1);
        this.store.onTextOptionsChanged((newValue, oldValue) => {
            this.debouncedOnTextOptionsChanged(this.imageEditor, newValue, oldValue);
        });

        this.store.canvas.on({
            'selection:updated': (event)=> this.onSelectText(this.imageEditor, event),
            'selection:created': (event)=> this.onSelectText(this.imageEditor, event)
        });
    }

    insertText() {
        let app = this;
        let canvas = app.store.canvas;

        let fontObserver = new FontFaceObserver(app.store.text.fontFamily);

        const onFontLoad = () => {
            const curvedText = new fabric.CurvedText(app.store.text.textMessage, {
                diameter: app.store.text.diameter,
                fontSize: app.store.text.fontSize,
                fontFamily: app.store.text.fontFamily,
                fill: app.store.text.fontColor,
                flipped: app.store.text.flipped,
                kerning: app.store.text.kerning,
                originX: 'center', originY: 'center'
            });

            // Add a circular text
            canvas.add(curvedText);
        }

        fontObserver.load(null).then(function () {
            onFontLoad();
        }).catch(function (e) {
            console.warn(`Font "${app.store.text.fontFamily}" is not available`, e);
            onFontLoad();
        });
    }

    onSelectText(editor, event) {
        for (let selectedElement of event.selected) {
            if (selectedElement instanceof fabric.CurvedText) {
                // editor.store.text.textAlign = selectedElement.textAlign;
                editor.store.text.fontColor = selectedElement.fill;
                editor.store.text.fontFamily = selectedElement.fontFamily;
                editor.store.text.diameter = Math.round(+selectedElement.diameter);
                editor.store.text.textMessage = selectedElement.text;
                editor.store.text.fontSize = selectedElement.fontSize;
                editor.store.text.flipped = selectedElement.flipped;
                editor.store.text.kerning = selectedElement.kerning;

                editor.store.text.old_fontSize = selectedElement.fontSize;
            }
        }
    }


    onTextOptionsChanged(editor, newValue, oldValue) {
        let activeObject = editor.store.canvas.getActiveObject();

        if (activeObject) {
            const onFontLoad = () => {
                activeObject.set({
                    // textAlign: editor.store.text.textAlign,
                    fill:  editor.store.text.fontColor,
                    fontFamily: editor.store.text.fontFamily,
                    diameter: editor.store.text.diameter,
                    text: editor.store.text.textMessage,
                    fontSize: editor.store.text.fontSize,
                    flipped: editor.store.text.flipped,
                    kerning: editor.store.text.kerning
                });

                editor.store.canvas.requestRenderAll();
                setTimeout(()=> {
                    editor.store.canvas.requestRenderAll();
                }, 100);
            }

            let fontObserver = new FontFaceObserver(editor.store.text.fontFamily);
            fontObserver.load(null).then(function () {
                onFontLoad();
            }).catch(function (e) {
                console.warn(`Font "${editor.store.text.fontFamily}" is not available`, e);
                onFontLoad();
            });
        }
    }

    toggleSideNavOnTextEdit ({store, canvas}) {
        fabric.IText.prototype.on('editing:entered', function() {
            if (!store.editorNav) return;

            $(store.editorNav).addClass('d-none');
        });

        fabric.IText.prototype.on('editing:exited', function() {
            canvas.calcOffset()

            if (!store.editorNav) return;

            $(store.editorNav).removeClass('d-none');
        });
    }
}
